var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "navBox",
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.styleObj.fontColor
    },
    on: {
      click: _vm.clickFun
    }
  }, [_vm.styleObj.controlsComponentsMark != "navigation4" ? _c("div", {
    staticClass: "nav",
    attrs: {
      id: "nav1"
    }
  }, _vm._l(_vm.navList, function (item, index) {
    return _c("div", {
      key: index,
      class: index == _vm.navIndex && _vm.styleObj.controlsComponentsMark == "navigation1" ? "hit" : index == _vm.navIndex && _vm.styleObj.controlsComponentsMark != "navigation1" ? "hit2" : "",
      style: index == _vm.navIndex ? "font-size:" + _vm.styleObj.fontSize + "px" : ""
    }, [_vm._v(" " + _vm._s(_vm.$t(item)) + " "), _vm.styleObj.controlsComponentsMark == "navigation1" ? _c("div", {
      staticClass: "heng"
    }) : _vm._e(), _vm.styleObj.controlsComponentsMark == "navigation2" && index == _vm.navIndex ? _c("img", {
      staticClass: "img",
      attrs: {
        src: require("@/assets/template/navigation/" + _vm.styleObj.controlsComponentsMark + "_" + _vm.fontColor + ".png")
      }
    }) : _vm._e(), _vm.styleObj.controlsComponentsMark == "navigation3" ? _c("img", {
      staticClass: "img3",
      attrs: {
        src: require("@/assets/template/navigation/" + _vm.styleObj.controlsComponentsMark + "_" + _vm.fontColor + ".png")
      }
    }) : _vm._e()]);
  }), 0) : _c("div", {
    staticClass: "nav",
    attrs: {
      id: "nav2"
    }
  }, _vm._l(_vm.navList, function (item, index) {
    return _c("div", {
      key: index,
      class: index == _vm.navIndex ? "hit" : ""
    }, [_c("svg-icon", {
      attrs: {
        icon: _vm.icon[index],
        size: 20
      }
    }), _c("span", {
      style: index == _vm.navIndex ? "font-size:" + _vm.styleObj.fontSize + "px" : ""
    }, [_vm._v(_vm._s(_vm.$t(item)))])], 1);
  }), 0), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };